/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Will_DeleteInputs */



/**
* | output |
* | --- |
* | "Will delete:" |
*
* @param {Suggestions_Will_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_will_delete = /** @type {((inputs?: Suggestions_Will_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Will_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird gelöscht:")
	return /** @type {LocalizedString} */ ("Will delete:")
});